/*
 * Infinite scroll for the collection product grid.
 * Progressive enhancement: the numbered pagination stays in the DOM as a
 * no-JS fallback (and as the source of the "next page" URL). When JS runs we
 * hide it, drop in a sentinel, and auto-load the next page as it nears the
 * viewport. Re-binds itself after Dawn re-renders the grid on filter/sort.
 */
(function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  var sentinel = null;
  var observer = null;
  var loading = false;

  function currentPagination() {
    return container.querySelector('.pagination-wrapper');
  }

  // Dawn's pagination snippet labels the NEXT-page arrow `pagination__item--prev`.
  function nextUrl() {
    var pag = currentPagination();
    if (!pag) return null;
    var link = pag.querySelector('.pagination__item--prev');
    return link ? link.getAttribute('href') : null;
  }

  function teardown() {
    if (observer) { observer.disconnect(); observer = null; }
    if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    sentinel = null;
  }

  function setup() {
    teardown();

    var pagination = currentPagination();
    if (!pagination || !nextUrl()) return; // single page or last page — nothing to do

    pagination.classList.add('infinite-hidden');

    sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll';
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.innerHTML =
      '<button type="button" class="infinite-scroll__button">Load more prints</button>' +
      '<span class="infinite-scroll__spinner" aria-hidden="true"></span>';
    pagination.parentNode.insertBefore(sentinel, pagination.nextSibling);

    var button = sentinel.querySelector('.infinite-scroll__button');
    button.addEventListener('click', loadMore);

    if ('IntersectionObserver' in window) {
      sentinel.classList.add('infinite-scroll--auto'); // CSS hides the manual button
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore();
      }, { rootMargin: '700px 0px' });
      observer.observe(sentinel);
    }
  }

  function loadMore() {
    if (loading || !sentinel) return;
    var url = nextUrl();
    if (!url) { teardown(); return; }

    loading = true;
    sentinel.classList.remove('infinite-scroll--error');
    sentinel.classList.add('infinite-scroll--loading');

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = container.querySelector('#product-grid');
        var newGrid = doc.getElementById('product-grid');

        if (grid && newGrid) {
          var items = newGrid.querySelectorAll('.grid__item');
          items.forEach(function (item) {
            // guarantee visibility even if reveal-on-scroll animations are on
            item.classList.remove('scroll-trigger');
            grid.appendChild(item);
          });
        }

        // swap the old pagination for the fetched one so nextUrl() advances
        var oldPag = currentPagination();
        var fresh = doc.getElementById('ProductGridContainer');
        var newPag = fresh ? fresh.querySelector('.pagination-wrapper') : null;
        if (oldPag) {
          if (newPag) {
            newPag.classList.add('infinite-hidden');
            oldPag.replaceWith(newPag);
          } else {
            oldPag.remove();
          }
        }

        loading = false;
        if (sentinel) {
          sentinel.classList.remove('infinite-scroll--loading');
          if (!nextUrl()) {
            teardown(); // reached the last page
          } else if (observer) {
            // Re-arm: the observer only fires on intersection *changes*, so a
            // sentinel that stays in view (short pages, fast scroll) needs a
            // fresh observation to keep pulling the following pages.
            observer.unobserve(sentinel);
            observer.observe(sentinel);
          }
        }
      })
      .catch(function () {
        loading = false;
        if (!sentinel) return;
        sentinel.classList.remove('infinite-scroll--loading', 'infinite-scroll--auto');
        sentinel.classList.add('infinite-scroll--error');
        var button = sentinel.querySelector('.infinite-scroll__button');
        if (button) button.textContent = 'Retry';
        if (observer) { observer.disconnect(); observer = null; }
      });
  }

  // Dawn replaces #ProductGridContainer's contents when filters/sort change.
  // When that wipes our sentinel, rebuild against the fresh page-1 results.
  var mo = new MutationObserver(function () {
    if (loading) return;
    if (!sentinel || !document.body.contains(sentinel)) setup();
  });
  mo.observe(container, { childList: true, subtree: true });

  setup();
})();
